import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const CommentListPage = () =>
  import('@modules/comment/components/comment-list-page.vue');
const CommentFormPage = () =>
  import('@modules/comment/components/comment-form-page.vue');
const CommentViewPage = () =>
  import('@modules/comment/components/comment-view-page.vue');
const CommentImporterPage = () =>
  import('@modules/comment/components/comment-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'comment',
        path: '/comment',
        component: CommentListPage,
        meta: {
          auth: true,
          permission: Permissions.values.commentView,
        },
      },
      {
        name: 'commentNew',
        path: '/comment/new',
        component: CommentFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.commentCreate,
        },
      },
      {
        name: 'commentImporter',
        path: '/comment/import',
        component: CommentImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.commentImport,
        },
      },
      {
        name: 'commentEdit',
        path: '/comment/:id/edit',
        component: CommentFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.commentEdit,
        },
        props: true,
      },
      {
        name: 'commentView',
        path: '/comment/:id',
        component: CommentViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.commentView,
        },
        props: true,
      },
    ],
  },
];
